module.exports = __webpack_public_path__ + "static/media/image.3b39e486.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Ecommerce/image.jpg
// module id = 79
// module chunks = 0